import { useQuery } from '@tanstack/react-query';
import { GET, GET_CHANNEL_BUY, GET_STORE_TYPE_CODE } from '..';
import { serviceOptions } from '../../functions/serviceOptions';

export const channelBuyQuery = () =>
  useQuery({
    queryKey: ['channelBuyQuery'],
    queryFn: async () => {
      const response = await GET(GET_CHANNEL_BUY());
      return serviceOptions('CHANNEL_BUY', response.result.items);
    },
  });

export const storeTypeCodeQuery = (storeTypeCode) =>
  useQuery({
    queryKey: ['storeTypeCodeQuery', storeTypeCode],
    queryFn: async () => {
      const response = await GET(GET_STORE_TYPE_CODE(storeTypeCode));
      return serviceOptions('STORE_TYPE_CODE', response.result.items);
    },
    enabled: !!storeTypeCode,
  });
